import { createGlobalStyle } from 'styled-components';
import GloriolaStd from 'assets/fonts/Gloriola/GloriolaStdRegular.otf';
import GloriolaStdMedium from 'assets/fonts/Gloriola/GloriolaStdMedium.otf';
import GloriolaStdSemibold from 'assets/fonts/Gloriola/GloriolaStdSemibold.otf';
import GloriolaStdBold from 'assets/fonts/Gloriola/GloriolaStdBold.otf';
import GloriolaStdIt from 'assets/fonts/Gloriola/GloriolaStdRegularIt.otf';
import GloriolaStdMediumIt from 'assets/fonts/Gloriola/GloriolaStdMediumIt.otf';
import GloriolaStdBoldIt from 'assets/fonts/Gloriola/GloriolaStdBoldIt.otf';
import GloriolaStdSemiboldIt from 'assets/fonts/Gloriola/GloriolaStdSemiboldIt.otf';

import SpaceGrotesk from 'assets/fonts/SpaceGrotesk/SpaceGrotesk-Regular.ttf';
import SpaceGroteskBold from 'assets/fonts/SpaceGrotesk/SpaceGrotesk-Bold.ttf';
import SpaceGroteskMedium from 'assets/fonts/SpaceGrotesk/SpaceGrotesk-Medium.ttf';

interface IGlobalStyle {
  host: string | undefined;
}

const GlobalStyle = createGlobalStyle<IGlobalStyle>`
  @font-face {
    font-family: 'Gloriola Std';
    font-weight: normal;
    font-style: normal;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${GloriolaStd}') format('opentype');
  }

  @font-face {
    font-family: 'Gloriola Std';
    font-weight: 500;
    font-style: normal;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${GloriolaStdMedium}') format('opentype');
  }

  @font-face {
    font-family: 'Gloriola Std';
    font-weight: 600;
    font-style: normal;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${GloriolaStdSemibold}') format('opentype');
  }

  @font-face {
    font-family: 'Gloriola Std';
    font-weight: bold;
    font-style: normal;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${GloriolaStdBold}') format('opentype');
  }

  @font-face {
    font-family: 'Gloriola Std';
    font-weight: normal;
    font-style: italic;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${GloriolaStdIt}') format('opentype');
  }

  @font-face {
    font-family: 'Gloriola Std';
    font-weight: 500;
    font-style: italic;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${GloriolaStdMediumIt}') format('opentype');
  }

  @font-face {
    font-family: 'Gloriola Std';
    font-weight: 600;
    font-style: italic;
    font-display: block;
    src: url('${props =>
      props.host
        ? props.host
        : ''}${GloriolaStdSemiboldIt}') format('opentype');
  }

  @font-face {
    font-family: 'Gloriola Std';
    font-weight: bold;
    font-style: italic;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${GloriolaStdBoldIt}') format('truetype');
  }

  @font-face {
    font-family: 'Space Grotesk';
    font-weight: normal;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${SpaceGrotesk}') format('truetype');
  }

  @font-face {
    font-family: 'Space Grotesk';
    font-weight: bold;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${SpaceGroteskBold}') format('opentype');
  }

  @font-face {
    font-family: 'Space Grotesk';
    font-weight: 500;
    font-display: block;
    src: url('${props =>
      props.host ? props.host : ''}${SpaceGroteskMedium}') format('opentype');
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    overflow-x: hidden;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    overflow-x: hidden;
    position: relative;

    font-size: ${props => `${props.theme.fontSize}px`};
    color: ${({ theme }) => theme.colors.neutralDark};
    line-height: ${props => `${props.theme.lineHeight}px`};
  }

  body#body{
    margin-right: 0px !important;
  }

  input, textarea, button {
    font-family: ${props => props.theme.fonts.primary};
  }

  button{
    font-weight: 500;
  }
  #app {
    height: 100vh;
  }

  [data-flora="modal-footer"]{
    justify-content: center;
    button {
      height: 32px;
      padding: 8px 20px;
      & + button {
        margin-left: 13px;
      }
    }
  }

  [data-flora="modal-body"]{
    text-align: center;
    color: ${({ theme }) => theme.colors.main};
  }
`;

export default GlobalStyle;
